import { DeliveryMethodsApiSdk } from '~api/DeliveryMethodsApiSdk';
import { diContainer } from '~setup/diContainer';
import serviceNames from '~setup/StoresService';

export interface ISetDeliveryMethodUseCaseParams {
    deliveryMethod: string;
    storeId?: string;
    skus?: number[];
}
export class SetDeliveryMethodUseCase {
    private deliveryMethodApi: DeliveryMethodsApiSdk;
    private params: ISetDeliveryMethodUseCaseParams;

    constructor(params: ISetDeliveryMethodUseCaseParams) {
        this.params = params;
        this.deliveryMethodApi = diContainer.get(serviceNames.DeliveryMethodApiSdk);
    }

    public execute = async () => {
        await this.deliveryMethodApi.setDeliveryMethod(this.params);
    };
}
